<template>
    <filters
        class="my-4"
        v-model="filters"
        date-filter
        @fetch="
            pagination.current_page = 1;
            fetch();
        "
    />
    <table-component
        :headers="[
            'Analista de Backoffice (ID e Nome)',
            'Produtor (ID e Nome)',
            'Início da sessão',
            'Fim da sessão',
            'IP do Acesso',
        ]"
        :loading="loading"
        :pagination="pagination"
        v-model="pagination"
        @fetch="fetch"
    >
        <tr v-for="history in impersonateHistory">
            <td class="px-3">
                {{ history.impersonator.id }} - {{ history.impersonator.name }}
            </td>
            <td class="px-3">
                {{ history.impersonated.id }} - {{ history.impersonated.name }}
            </td>
            <td class="px-3">{{ formatDate(history.created_at) }}</td>
            <td class="px-3">{{ formatDate(history.updated_at) }}</td>
            <td class="px-3">{{ history.metadata.ip }}</td>
        </tr>
    </table-component>
</template>

<script>
import { TransitionRoot } from "@headlessui/vue";
import FormToggle from "../../components/forms/FormToggle.vue";
import VueSelect from "../../components/forms/VueSelect.vue";
import TictoLoading from "../../components/layouts/TictoLoading.vue";
import { useToast } from "vue-toastification";
import Filters from "../../components/layouts/Filters.vue";
import TableComponent from "../../components/layouts/table/TableComponent.vue";

export default {
    props: ["user"],
    components: {
        TableComponent,
        Filters,
        VueSelect,
        TransitionRoot,
        FormToggle,
        TictoLoading,
    },

    setup() {
        const toast = useToast();
        return { toast };
    },

    data() {
        return {
            impersonateHistory: [],

            loading: false,
            filters: {},

            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 11,
                from: 1,
                to: 11,
            },
        };
    },

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;
            this.impersonateHistory = [];

            axios
                .get(`/api/user/${this.user.id}/impersonate`, {
                    params: {
                        page: this.pagination.current_page,
                        ...this.filters,
                    },
                })
                .then(({ data }) => {
                    this.impersonateHistory = data.data;
                    this.pagination = data;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        formatDate(dateString) {
            const options = {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            };
            return new Date(dateString).toLocaleString("pt-BR", options);
        },
    },
};
</script>
